import { Edit, Mail, MapPin, Phone } from "lucide-react";
import React, { useContext, useEffect, useState } from "react";
import { Dropdown, Form, Modal } from "react-bootstrap";
import Profile from "../Assets/Img/ProfileLogo.png";
import { GlobalContext } from "../../utils/GlobalContext";
import "../Assets/css/index.css";
import facebook from "../Assets/Img/facebook.png";
import instagram from "../Assets/Img/instagram.png";
import LinkedIn from "../Assets/Img/LinkedIn.png";
import youtube from "../Assets/Img/youtube.png";
import axiosMain from "../http/axiosMain";

export default function MyProfile() {
  const { setUserData: setContextUserData } = useContext(GlobalContext);
  // State to manage modal visibility for both profile and setup modals
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [showEditProfileAboutBrandModal, setShowEditProfileAboutBrandModal] =
    useState(false);
  const [showProfileSetupModal, setShowProfileSetupModal] = useState(false);

  const [step, setStep] = useState(1);

  // State for profile details
  const [selectedState, setSelectedState] = useState("");
  const [category, setCategory] = useState([]);

  const statesWithCities = {
    Maharashtra: ["Mumbai", "Pune", "Nagpur"],
    Gujarat: ["Ahmedabad", "Surat", "Vadodara"],
    Karnataka: ["Bangalore", "Mysore", "Hubli"],
  };

  const [profileDetails, setProfileDetails] = useState({
    user_photo: "",
    brand_name: "",
    phone_no: "",
    email: "",
    file: "",
    address: "",
    pincode: "",
    categories: [], // ✅ This is correct
  });
  const fetchBrandProfile = async () => {
    try {
      const response = await axiosMain.get("/api/v1/get-brand-profile");
      console.log("Brand Profile Response:", response);

      if (
        response.data?.user &&
        Object.keys(response.data?.user || {})?.length
      ) {
        setContextUserData(response.data.user);
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      const brandName = response.data?.user?.brand_name; // Adjust the key based on your API response

      if (brandName) {
        localStorage.setItem("brandName", brandName);
      }

      setProfileDetails(response.data.user);
      setCategory(response.data);
    } catch (error) {
      console.error("Error fetching brand profile:", error);
    }
  };

  useEffect(() => {
    fetchBrandProfile();
  }, []);

  const [profileSetupDetails, setProfileSetupDetails] = useState({
    bio: "",
    website: "",
    social_Links: [],
  });
  const cities = ["Mumbai", "Ahmedabad", "Bangalore"];
  const [file, setFile] = useState(null);
  const [selectedFilteName, setSelectedFilteName] = useState("");

  // const handleCheckboxChange = (value, type) => {
  //   if (type === "category") {
  //     setProfileDetails((prev) => ({
  //       ...prev,
  //       categories: Array.isArray(prev.categories)
  //         ? prev.categories.includes(value)
  //           ? prev.categories.filter((v) => v !== value)
  //           : [...prev.categories, value]
  //         : [value], // Ensure it remains an array
  //     }));
  //   }
  // };

  // Toggle modal visibility for Edit Profile
  const handleCloseEditProfileModal = () => setShowEditProfileModal(false);
  const handleShowEditProfileModal = () => setShowEditProfileModal(true);
  const handleCloseEditProfileAboutBrandModal = () =>
    setShowEditProfileAboutBrandModal(false);
  const handleShowEditProfileAboutBrandModal = () =>
    setShowEditProfileAboutBrandModal(true);

  // Toggle modal visibility for Profile Setup
  const handleShowProfileSetupModal = () => setShowProfileSetupModal(true);
  const handleCloseProfileSetupModal = () => {
    setShowProfileSetupModal(false);
    setStep(1); // Reset the step to 1
  };

  // Handle logo upload for profile setup
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setProfileSetupDetails((prevState) => ({
          ...prevState,
          logo: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle profile edit form submission
  const handleProfileSave = () => {
    setShowEditProfileModal(false);
    setShowEditProfileAboutBrandModal(false);
  };

  // Handle form submission for profile setup
  const handleSaveProfileSetup = () => {
    // Logic to save the profile setup
    console.log("Profile setup saved:", profileSetupDetails);
    setShowProfileSetupModal(false);
  };

  // Handle step change in profile setup
  const handleNextStep = () => {
    if (step < 2) {
      setStep(step + 1);
    }
  };

  const handlePreviousStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  // Handle form input changes for profile setup
  const handleInputChange = (e, field) => {
    setProfileSetupDetails({
      ...profileSetupDetails,
      [field]: e.target.value,
    });
  };

  // Handle social media link changes
  const handleSocialLinkChange = (index, value) => {
    setProfileSetupDetails((prevState) => {
      const updatedLinks = [...prevState.socialLinks];
      updatedLinks[index].url = value;
      return { ...prevState, socialLinks: updatedLinks };
    });
  };

  // Add a new social media link input field
  const handleAddSocialLink = () => {
    setProfileSetupDetails({
      ...profileSetupDetails,
      socialLinks: [
        ...profileSetupDetails.socialLinks,
        { platform: "New Platform", url: "" },
      ],
    });
  };
  const handleOpenProfileSetupModal = () => {
    setShowEditProfileModal(false);
    setShowEditProfileAboutBrandModal(false);
    setShowProfileSetupModal(true);
  };
  // const categories = ["Fashion", "Sports", "Lifestyle", "Technology", "Beauty"];
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedCity, setSelectedCity] = useState("");
  const [categories, setCategories] = useState([]); // Store API categories

  // Ensure category is an array
  // const selectedCategories = Array.isArray(profileDetails.category)
  //   ? profileDetails.category
  //   : [];

  // const handleCheckboxChange = (category) => {
  //   setProfileDetails((prevState) => ({
  //     ...prevState,
  //     category: selectedCategories.includes(category)
  //       ? selectedCategories.filter((c) => c !== category) // Remove if already selected
  //       : [...selectedCategories, category], // Add if not selected
  //   }));
  // };

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null); // Track which dropdown is open

  // const handleCheckboxChange = (value, type) => {
  //   if (type === "category") {
  //     setSelectedCategories((prev) =>
  //       prev.includes(value)
  // ? prev.filter((v) => v !== value)
  //         : [...prev, value]
  //     );
  //   } else {
  //     setSelectedStates((prev) =>
  //       prev.includes(value)
  //         ? prev.filter((v) => v !== value)
  //         : [...prev, value]
  //     );
  //   }
  // };
  const [showNextModal, setShowNextModal] = useState(false);
  // Function to close the Edit Profile modal and open the Next modal
  const handleOpenNextModal = () => {
    setShowEditProfileModal(false);
    setShowEditProfileAboutBrandModal(false);
    setShowNextModal(true);
  };

  // Function to close the Next modal
  const handleCloseNextModal = () => {
    setShowNextModal(false);
  };
  const [activeSection, setActiveSection] = useState("profile"); // "profile" or "editDetails"
  const handleProfilePicClick = () => {
    setActiveSection("profile");
  };

  const handleEditDetailsClick = () => {
    setActiveSection("editDetails");
  };
  const [userData, setUserData] = useState(null);
  const fetchUserData = async () => {
    try {
      // const userId = localStorage.getItem("userId");
      const userRaw = localStorage.getItem("user");
      let userData = {};
      try {
        userData = userRaw ? JSON.parse(userRaw) : {};
      } catch (error) {
        console.error("Error parsing user data from localStorage:", error);
      }

      const userId = userData?.user?.user_id;

      if (userId) {
        const response = await axiosMain.get("/api/v1/user", {
          params: { user_id: userId },
        });

        setUserData(response.data.user);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  // Example Usage
  useEffect(() => {
    fetchUserData();
  }, []);

  const [step1, setstep1] = useState(true);
  const handleNext = () => [setstep1(!step1)];

  const handleSaveProfileModalOne = async () => {
    // const requestData = {
    //   brand_name: profileDetails.brand_name,
    //   user_photo: profileDetails.user_photo,
    //   categories: profileDetails.categories || [],
    // };

    // Create a FormData object
    const formData = new FormData();

    // Append non-file fields 
    await Object.keys(profileDetails).forEach((key) => {
      if (key === "file") {
        const fileData = profileDetails.file;
        // ✅ Check if the file is a Buffer and convert it to a Blob
        if (fileData?.buffer) {
          const blob = new Blob([fileData.buffer], { type: fileData.mimetype });
          formData.append("file", blob, fileData.originalname);
        } else if (fileData instanceof File) {
          formData.append("file", fileData);
        } else {
          console.error("Invalid file format:", fileData);
        }
      }
      if (key === "categories") {
        formData.append(
          "categories",
          profileDetails.categories.length > 0 ? profileDetails.categories : " "
        );
      }
      if (key === "brand_name") {
        formData.append("brand_name", profileDetails.brand_name || "");
      }
    });

    console.log("Sending API RequestProfile:", formData);

    try {
      const response = await axiosMain.put(
        "/api/v1/update-photo-categories",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Ensure correct content type
          },
        }
      );

      console.log("API Response:", response.data); // Log API response

      if (response.status === 200) {
        alert("Profile updated successfully!");


        fetchBrandProfile();

        // Store updated profile in localStorage
        const updatedProfile = {
          ...profileDetails,
          categories: response.data.categories || [], // Ensure categories are updated
        };
        localStorage.setItem("profileDetails", JSON.stringify(updatedProfile));

        // Update state properly
        setProfileDetails((prev) => ({
          ...prev,
          categories: response.data.categories || [], // Ensure categories update
        }));

        console.log("Updated State:", updatedProfile); // Log updated profile to verify

        handleCloseEditProfileModal();
      } else {
        alert("Something went wrong!");
      }
    } catch (error) {
      console.error(
        "API Error:",
        error.response ? error.response.data : error.message
      );
      alert("Failed to update profile.");
    }
  };
  // const [categories, setCategories] = useState([]); // Initialize categories as an empty array

  // Load profile details from localStorage on mount
  useEffect(() => {
    const storedProfile = localStorage.getItem("profileDetails");
    if (storedProfile) {
      try {
        const parsedProfile = JSON.parse(storedProfile);

        setProfileDetails((prev) => ({
          ...prev,
          categories:
            typeof parsedProfile.categories === "string"
              ? parsedProfile.categories.split(",") // Convert to array
              : Array.isArray(parsedProfile.categories)
              ? parsedProfile.categories // Use as is
              : [], // Fallback to empty array
        }));
      } catch (error) {
        console.error("Error parsing profileDetails from localStorage:", error);
      }
    }
  }, []);

  // Handle file upload
  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setProfileDetails((prev) => ({
  //       ...prev,
  //       user_photo: file, // Store file object
  //       user_photo_preview: URL.createObjectURL(file), // Create preview URL
  //     }));
  //   }
  // };
  const handleFileSelect = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();

      reader.onload = async (event) => {
        const arrayBuffer = event.target.result;

        const buffer = new Uint8Array(arrayBuffer); // Convert ArrayBuffer to Uint8Array

        // Create an object similar to what the backend expects
        const fileData = {
          fieldname: "file",
          originalname: selectedFile.name,
          encoding: "7bit",
          mimetype: selectedFile.type,
          buffer: buffer, // This is a Uint8Array, similar to a Buffer in Node.js
          size: selectedFile.size,
        };

        setFile(fileData);
        setSelectedFilteName(selectedFile.name);
        setProfileDetails({ ...profileDetails, file: fileData });
      };

      reader.readAsArrayBuffer(selectedFile); // Read file as ArrayBuffer (binary data)
    }
  };

  // get call for categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axiosMain.get("/api/v1/get-categories");
        if (response.data && response.data.categories) {
          setCategories(response.data.categories); // Store API response
        } else {
          console.error("Invalid category format received:", response.data);
          setCategories([]); // Fallback to empty array
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategories([]); // Fallback to empty array
      }
    };

    fetchCategories();
  }, []);
  // Handle category selection
  const handleCheckboxChange = (category) => {
    setProfileDetails((prevDetails) => {
      const selectedCategories = prevDetails.categories || []; // Ensure array
      const isSelected = selectedCategories.includes(category);

      return {
        ...prevDetails,
        categories: isSelected
          ? selectedCategories.filter((c) => c !== category) // Uncheck
          : [...selectedCategories, category], // Add new
      };
    });
  };

  const handleSaveAboutBrandModal = async () => {
    const updatedProfile = {
      ...profileDetails,
      state: selectedState || profileDetails.state,
      city: selectedCity || profileDetails.city,
    };
    handleCloseEditProfileAboutBrandModal();
    console.log("Saving Profile with Data:", updatedProfile);

    try {
      const response = await axiosMain.put(
        "/api/v1/update-bio-location-social",
        updatedProfile,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        console.log("Profile updated successfully", response.data);

        setProfileDetails((prev) => ({
          ...prev,
          bio: response.data.bio || prev.bio,
          phone_no: response.data.phone || prev.phone_no,
          email: response.data.email || prev.email,
          address: response.data.address || prev.address,
          state: response.data.state || prev.state,
          city: response.data.city || prev.city,
          pincode: response.data.pin || prev.pincode,
          // social_links: response.data.social_Links || prev.social_links,
        }));

        alert("Profile updated successfully!");
        // ✅ Fetch the latest profile data to keep UI in sync
        fetchBrandProfile();
        handleCloseEditProfileAboutBrandModal();
      } else {
        console.error("Error updating profile", response.statusText);
        alert("Failed to update profile");
      }
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      alert("Something went wrong. Please try again.");
    }
  };
  const handleStateSelect = (state) => {
    setSelectedState(state);
    setSelectedCity(""); // Reset city when state changes
    setProfileDetails((prev) => ({
      ...prev,
      state: state,
      city: "",
    }));
  };

  const handleCitySelect = (city) => {
    setSelectedCity(city);
    setProfileDetails((prev) => ({
      ...prev,
      city: city,
    }));
  };

  const getProfileImage = (userDetails, fileData) => {
    if (fileData?.buffer) {
      // Convert ArrayBuffer to Blob
      const blob = new Blob([fileData?.buffer], { type: "image/png" }); // Change type based on your image format

      // Create a URL for the Blob
      const imageUrl = URL.createObjectURL(blob);

      return imageUrl;
    } else {
      return userDetails?.user_photo || Profile;
    }
  };

  return (
    <div className="MyProfile">
      <div className="container-fluid">
        <div className="CardBox mx-auto">
          {/* Brand Header */}
          <div className="ProfileBanner d-flex justify-content-between align-items-center position-relative">
            <div className="ProfileEditLogo">
              <img
                src={profileDetails?.user_photo || Profile}
                alt="Puma Logo"
                className="img-fluid"
              />
              {profileDetails?.brand_name ? (
                <div>
                  <h1 className="h5">{profileDetails?.brand_name}</h1>
                  <div className="text-muted">
                    {category?.categories?.filter(Boolean)?.length > 0 ? (
                      <p className="text-muted">
                        {category?.categories?.filter(Boolean).join(", ")}
                      </p>
                    ) : (
                      <p className="text-muted">No categories available</p>
                    )}
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>

            <button
              className="btn btn-link position-absolute top-0 end-0 text-muted"
              onClick={handleShowEditProfileModal}
            >
              <Edit className="h4 w-4" />
            </button>
          </div>

          <div className="ProfileDetails">
            {/* About Section */}
            <div className="mb-4">
              <div className="d-flex justify-content-between">
                <h2 className="h6">About Brand</h2>
                <button
                  className="btn btn-link text-muted"
                  onClick={handleShowEditProfileAboutBrandModal}
                >
                  <Edit className="h4 w-4" />
                </button>
              </div>
              <p className="text-muted">
                {profileDetails?.bio || "No bio available."}
              </p>
            </div>

            {/* Contact Section */}
            <div className="mb-4">
              <h2 className="h6">Contact</h2>
              <div className="list-unstyled">
                {profileDetails?.email ? (
                  <div className="d-flex align-items-center mb-2">
                    <Mail className="me-2" />
                    {/* <a
                    href={`mailto:${profileDetails.email}`}
                    className="text-muted"
                  > */}
                    {profileDetails?.email}
                    {/* </a> */}
                  </div>
                ) : (
                  <></>
                )}
                {profileDetails?.phone_no ? (
                  <div className="d-flex align-items-center mb-2">
                    <Phone className="me-2" />
                    {/* <a
                    href={`tel:${profileDetails.phone_no}`}
                    className="text-muted"
                  > */}
                    {profileDetails?.phone_no}
                    {/* </a> */}
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>

            {/* Location Section */}
            <div className="mb-4">
              <h2 className="h6">Location</h2>
              <div className="d-flex align-items-start">
                <MapPin className="me-2" />
                <p className="text-muted">
                  {[
                    profileDetails?.address,
                    profileDetails?.city,
                    profileDetails?.state,
                    profileDetails?.pincode,
                  ]
                    ?.filter(Boolean)
                    ?.join(", ") || "N/A"}
                </p>
              </div>
            </div>

            {/* Social Links Section */}
            <div>
              <h2 className="h6">Social Links</h2>
              <div className="d-flex flex-wrap gap-5">
                <a
                  href="https://instagram.com/Puma.com"
                  className="d-flex align-items-center text-muted"
                >
                  <img src={instagram} className="img-fluid" alt="instagram" />
                  &nbsp;
                  <span>instagram/puma.com</span>
                </a>
                <a
                  href="https://youtube.com/Puma.com"
                  className="d-flex align-items-center text-muted"
                >
                  <img src={youtube} className="img-fluid" alt="youtube" />
                  &nbsp;
                  <span>youtube/puma.com</span>
                </a>
                <a
                  href="https://facebook.com/Puma.com"
                  className="d-flex align-items-center text-muted"
                >
                  <img src={facebook} className="img-fluid" alt="facebook" />
                  &nbsp;
                  <span>facebook/puma.com</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/** Edit Profile ModalOne */}

      <Modal
        className="ModalBox"
        show={showEditProfileModal}
        onHide={handleCloseEditProfileModal}
        centered
      >
        <Modal.Body>
          {/* Close Button */}
          <button
            type="button"
            className="btn-close"
            style={{
              position: "absolute",
              top: "10px",
              right: "15px",
              background: "none",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
              
            }}
            onClick={handleCloseEditProfileModal}
          >
            ✖
          </button>
          <div className="TitleTag">Let’s setup your Profile!</div>

          <Form>
            {/* Logo Upload Section */}
            <Form.Group controlId="formLogo" className="text-center">
              <div className="d-flex flex-column align-items-center">
                {/* Clickable Image to Upload */}
                <label htmlFor="fileUpload" className="position-relative">
                  <img
                    src={getProfileImage(profileDetails, file)} // Use user_photo instead of logo
                    alt="Logo Preview"
                    className="rounded-circle"
                    style={{
                      width: "134px",
                      height: "134px",
                      objectFit: "cover",
                      cursor: "pointer",
                      border: "2px solid #ddd",
                      display: "block",
                    }}
                  />
                </label>

                {/* Hidden File Input */}
                <Form.Control
                  id="fileUpload"
                  type="file"
                  accept=".jpg,.png"
                  className="d-none"
                  onChange={handleFileSelect}
                />
                {selectedFilteName ? (
                  <p className="mt-2">Selected file: {selectedFilteName}</p>
                ) : (
                  <></>
                )}
              </div>
            </Form.Group>

            {/* Two-Column Layout */}
            <div className="row mt-2">
              {/* Brand Name */}
              <div className="col-md-6">
                <Form.Group controlId="formName">
                  <Form.Label>Your Brand's Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={profileDetails?.brand_name} // Use brand_name instead of name
                    onChange={(e) =>
                      setProfileDetails({
                        ...profileDetails,
                        brand_name: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </div>
              {/* Brand Category Dropdown */}
              <div className="col-md-6">
                <Form.Group controlId="formCategory">
                  <Form.Label>Select Your Brand's Category</Form.Label>
                  <Dropdown
                    show={openDropdown === "category"}
                    onToggle={(isOpen) =>
                      setOpenDropdown(isOpen ? "category" : null)
                    }
                    className="w-100"
                  >
                    <Dropdown.Toggle
                      variant="light"
                      className="w-100 drop text-start"
                    >
                      {profileDetails?.categories?.length > 0
                        ? profileDetails.categories.join(", ")
                        : "Select Categories"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="w-100 p-2">
                      {categories.map((category, index) => (
                        <div key={index} className="dropdown-item">
                          <Form.Check
                            type="checkbox"
                            label={category}
                            checked={profileDetails?.categories?.includes(
                              category
                            )}
                            onChange={() => handleCheckboxChange(category)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
              </div>
              </div>
            {/* </div> */}

            <div className="d-flex justify-content-between mt-4 mb-3">
              <button type="button" className="btn profile-clear-btn">
                Clear All
              </button>
              <div>
                <button
                  type="button"
                  className="profile btn btn-outline-success mx-2"
                  onClick={handleSaveProfileModalOne}
                >
                  Save
                </button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Profile About Brand Modal */}
      <Modal
        className="ModalBox"
        show={showEditProfileAboutBrandModal}
        onHide={handleCloseEditProfileAboutBrandModal}
      >
        <Modal.Body>
          {/* Close Button */}
          <button
            type="button"
            className="btn-close"
            style={{
              position: "absolute",
              top: "10px",
              right: "15px",
              background: "none",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={handleCloseEditProfileAboutBrandModal}
          >
            ✖
          </button>
          <div className="TitleTag">Let’s setup your Profile!</div>

          <Form>
            {step1 ? (
              <>
                <div className="row">
                     {/* Email ID */}
                     <div className="col-md-6">
                    <Form.Group controlId="formEmail">
                      <Form.Label>Email ID</Form.Label>
                      <Form.Control
                        type="email"
                        value={profileDetails?.email}
                        onChange={(e) =>
                          setProfileDetails({
                            ...profileDetails,
                            email: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </div>

                  {/* Phone Number */}
                  <div className="col-md-6">
                    <Form.Group controlId="formPhone">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={profileDetails?.phone_no || " "}
                        onChange={(e) =>
                          setProfileDetails({
                            ...profileDetails,
                            phone_no: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </div>

                  {/* State Dropdown */}
                  <div className="col-md-6">
                    <Form.Group controlId="formState">
                      <Form.Label>State</Form.Label>
                      <Dropdown
                        show={openDropdown === "state"}
                        onToggle={(isOpen) =>
                          setOpenDropdown(isOpen ? "state" : null)
                        }
                        className="w-100"
                      >
                        <Dropdown.Toggle
                          variant="light"
                          className="w-100 drop text-start"
                        >
                          {selectedState || "Select State"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="w-100 p-2">
                          {Object.keys(statesWithCities).map((state, index) => (
                            <Dropdown.Item
                              key={index}
                              onClick={() => handleStateSelect(state)}
                            >
                              {state}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Form.Group>
                  </div>

                  {/* City Dropdown */}
                  <div className="col-md-6">
                    <Form.Group controlId="formCity">
                      <Form.Label>City</Form.Label>
                      <Dropdown
                        show={openDropdown === "city"}
                        onToggle={(isOpen) =>
                          setOpenDropdown(isOpen ? "city" : null)
                        }
                        className="w-100"
                      >
                        <Dropdown.Toggle
                          variant="light"
                          className="w-100 drop text-start"
                        >
                          {selectedCity || "Select City"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="w-100 p-2">
                          {selectedState ? (
                            statesWithCities[selectedState].map(
                              (city, index) => (
                                <Dropdown.Item
                                  key={index}
                                  onClick={() => handleCitySelect(city)}
                                >
                                  {city}
                                </Dropdown.Item>
                              )
                            )
                          ) : (
                            <Dropdown.Item disabled>
                              Select a State first
                            </Dropdown.Item>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Form.Group>
                  </div>

                  {/* Address */}
                  <div className="col-md-6">
                    <Form.Group controlId="formAddress">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        type="text"
                        value={profileDetails.address}
                        onChange={(e) =>
                          setProfileDetails({
                            ...profileDetails,
                            address: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </div>

                  {/* PIN Code */}
                  <div className="col-md-6">
                    <Form.Group controlId="formPin">
                      <Form.Label>PIN Code</Form.Label>
                      <Form.Control
                        type="text"
                        value={profileDetails.pincode || ""}
                        onChange={(e) =>
                          setProfileDetails({
                            ...profileDetails,
                            pincode: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </div>
                </div>
                {/* Brand Bio (Full Width) */}
                <div className="col-md-12 mt-3">
                  <Form.Group controlId="formBio">
                    <Form.Label>Brand’s Bio</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={profileDetails?.bio}
                      onChange={(e) =>
                        setProfileDetails({
                          ...profileDetails,
                          bio: e.target.value,
                        })
                      }
                      placeholder="Tell us about your brand..."
                    />
                  </Form.Group>
                </div>
              </>
            ) : (
              <>
                <Form.Group controlId="formWebsite">
                  <Form.Label>Your Brand’s Website (Optional)</Form.Label>
                  <Form.Control
                    type="text"
                    value={profileSetupDetails.website}
                    onChange={(e) => handleInputChange(e, "website")}
                  />
                </Form.Group>

                <h5>Brand’s Social Media Links</h5>
                {profileSetupDetails.socialLinks.map((link, index) => (
                  <Form.Group key={index} controlId={`formSocialLink${index}`}>
                    <Form.Label>{link.platform}</Form.Label>
                    <div className="input-container">
                      <img
                        src={
                          link.platform === "Instagram"
                            ? instagram
                            : link.platform === "YouTube"
                            ? youtube
                            : link.platform === "Facebook"
                            ? facebook
                            : LinkedIn
                        }
                        alt={link.platform}
                        className="social-icon"
                      />
                      <Form.Control
                        type="text"
                        placeholder={`Enter ${link.platform} URL`}
                        value={link.url}
                        onChange={(e) =>
                          handleSocialLinkChange(index, e.target.value)
                        }
                      />
                    </div>
                  </Form.Group>
                ))}
              </>
            )}

            <div className="d-flex justify-content-between mt-4 mb-3">
              <button type="button" className="btn profile-clear-btn">
                Clear All
              </button>
              <div>
                <button
                  type="button"
                  className="profile btn btn-outline-success mx-2"
                  onClick={handleSaveAboutBrandModal} // Call API on button click
                >
                  Save
                </button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}